import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { NAV_RAIL_BG } from 'utils/brand-colors'

/** Tight rail: icon + label without excess horizontal slack */
const SIDEBAR_WIDTH_PX = 192

export const RailContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$inDrawer' && prop !== '$fullHeight',
})<{ $inDrawer?: boolean; $fullHeight?: boolean }>(({ $inDrawer, $fullHeight }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  width: $inDrawer ? '100%' : SIDEBAR_WIDTH_PX,
  minWidth: $inDrawer ? 0 : SIDEBAR_WIDTH_PX,
  maxWidth: $inDrawer ? 'none' : SIDEBAR_WIDTH_PX,
  /* Drawer: full sheet. Desktop: stretch with app main column (flex chain). */
  flex: $fullHeight ? undefined : '1 1 0%',
  height: $fullHeight ? '100%' : '100%',
  minHeight: $fullHeight ? '100dvh' : 0,
  maxHeight: $fullHeight ? undefined : '100%',
  position: 'relative',
  top: 0,
  left: 0,
  backgroundColor: NAV_RAIL_BG,
  borderRight: 'none',
  overflow: 'hidden',
}))

export const SIDEBAR_WIDTH = SIDEBAR_WIDTH_PX
